export default __webpack_public_path__ + "static/brand-logo-be9bc8b4bc1b38e37aef692785239afd.png";